export default [
  {
    title: "Data Management",
    customIcon: "CustomSVG",
    children: [
      {
        title: "Merchant Selling Performance",
        route: "custom-module",
        path: "/custom-module/merchantsellingperformance",
      },
    ],
  },
];
